import React, { useState } from "react";
import {
  Grid2,
  Box,
  Typography,
  CardMedia,
  Button,
  IconButton,
  CircularProgress,
  Paper,
  TextField,
  InputAdornment,
} from "@mui/material";
import Images from "../../assets/images";
import Colors from "../../assets/styles";
import "@fontsource/poppins";
import "@fontsource/open-sans";
import { useForm } from "react-hook-form";
import InputField from "../../components/inputfield";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import AuthServices from "../../apis/AuthServices/index";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";

const Grid = (props) => <Grid2 {...props} />;

const parseMaybeJson = (value) => {
  let current = value;
  for (let i = 0; i < 4; i++) {
    if (typeof current !== "string") break;
    const trimmed = current.trim();
    if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) break;
    try {
      current = JSON.parse(trimmed);
    } catch (e) {
      break;
    }
  }
  return current;
};

const extractSession = (payload) => {
  let current = parseMaybeJson(payload);
  for (let i = 0; i < 5; i++) {
    if (!current || typeof current !== "object" || Array.isArray(current)) break;
    const token =
      current.Token ||
      current.token ||
      current.AccessToken ||
      current.access_token;
    if (token) {
      return { ...current, Token: token };
    }
    const nested = parseMaybeJson(
      current.Response ?? current.response ?? current.Data ?? current.data
    );
    if (!nested || nested === current) break;
    current = nested;
  }
  if (current && typeof current === "object" && !Array.isArray(current)) {
    return current;
  }
  return null;
};

function Login() {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const { userLogin } = useAuth();
  const navigate = useNavigate();

  const submit = async (formData) => {
    setIsLoading(true);
       

    const obj = {
      UserName: formData.email,
      Password: formData.password,
    };
    try {
      const result = await AuthServices.login(obj);
      const parsed = parseMaybeJson(result);
      const isSuccess =
        parsed?.IsSuccess === true ||
        parsed?.isSuccess === true ||
        parsed?.IsSuccess == true;
      const session = extractSession(parsed) || {};
      const token =
        session.Token ||
        session.token ||
        session.UserName ||
        session.userName ||
        formData.email;

      if (isSuccess && token) {
        userLogin({
          ...session,
          UserName: session.UserName || session.userName || formData.email,
          Token: token,
        });
        SuccessToaster("Login Successful");
        navigate("/dashboard");
      } else {
        ErrorToaster("Invalid Credentials");
      }
    } catch (error) {
      ErrorToaster("Invalid Credentials");
    } finally {
      setIsLoading(false);
    }
  };

  return (
   
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:"#133e02"
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: { xs: "20px", sm: "30px", md: "40px" }, // Responsive padding
          borderRadius: "16px",
          width: { xs: "90%", sm: "400px", md: "450px" }, // Responsive width
          textAlign: "center",
        }}
      >
		<Box sx={{display:'flex',justifyContent:"center", mb: 4,}}>
        <CardMedia
          component={"img"}
          src={Images.logo}
          alt={"logo"}
          sx={{
            width: { lg: "55%", md: "55%", sm: "55%", xs: "60%" },

            objectFit: "contain",
          }}
        />
			</Box>
       
      

        <form onSubmit={handleSubmit(submit)}>

          <TextField
            label="User Name"
            type="text"
            variant="outlined"
            fullWidth
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: Colors.primary,
                },
              "& label.Mui-focused": {
                color: Colors.primary,
              },
              fontSize: { xs: "0.9rem", sm: "1rem" }, // Responsive font size
            }}
            {...register("email", {
              required: "Username is required",
             
            })}
            error={!!errors.email}
            helperText={errors.email ? errors.email.message : ""}
          />

          <TextField
            label="Password"
            type={isVisible ? "text" : "password"}
            variant="outlined"
            fullWidth
            {...register("password", { required: "Password is required" })}
            error={!!errors.password}
            helperText={errors.password ? errors.password.message : ""}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: Colors.primary,
                },
              "& label.Mui-focused": {
                color: Colors.primary,
              },
              fontSize: { xs: "0.9rem", sm: "1rem" }, // Responsive font size
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setIsVisible(!isVisible)}
                    edge="end"
                  >
                    {isVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            type={"submit"}
            fullWidth
            variant={"contained"}
            sx={{
              background: "#133e02",
              color: Colors.white,
              borderRadius: "8px",
              p: "14px 40px",
              "&.Mui-disabled": {
                background: "#133e02",
              },
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress
                sx={{
                  "&.MuiCircularProgress-root": {
                    width: "26px !important",
                    height: "26px !important",
                  },
                  color: "#3f8325",
                }}
              />
            ) : (
              "Login"
            )}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default Login;
